import React from 'react';
import StatusIcon from "../../../Shared/Invoices/StatusIcon";
import {l, t} from "../../../I18n/i18n";

const OphtalmologistEarningLine = ({invoice}) => {
    const [expanded, setExpanded] = React.useState(false);

    const renderLine = () => {
        const amount = invoice.amount / 100.0;
        return <div>
            <div style={{display: "flex", gap: 10}} onClick={() => setExpanded(!expanded)}>
                <div className="row valign-wrapper clickable" style={{flex: 1}}>
                    <div className="col s3">
                        {t("MONITORING_PAGE.INCOME_FOR")}{l(`MONTH.${invoice.month}`)} {invoice.year}
                    </div>
                    <div className="col s3">
                        {amount.toFixed(2)}€
                    </div>
                </div>
                <a className="btn-small blue darken-2 z-depth-0" target={"_blank"}
                   href={`/admin/statistics/ophtalmologist/invoice/${invoice.id}/viewer`}>
                    {t("MONITORING_PAGE.VIEW_DOCUMENT")}
                </a>
                <a className="btn-small transparent btn-flat">
                    <i className={`material-icons ${expanded ? "flipped" : ""}`}>expand_more</i>
                </a>
            </div>

            {renderExpanded()}
        </div>
    }

    const renderExpanded = () => {
        if (!expanded) return null
        return <div style={{paddingLeft: 20, display: "flex", flexDirection: "column", gap: 10, paddingBlock: 5}}>
            <h5 style={{margin: 0}}>{t("TOTAL")} HN : {invoice.hn_total / 100.0}€</h5>
            <h5 style={{margin: 0}}>{t("MONITORING_PAGE.TOTAL_RETRO")} : {invoice.retrocession_total / 100.0}€</h5>
            {renderRetrocessionDetail()}
        </div>
    }

    const renderRetrocessionDetail = () => {
        if (!invoice.retrocessions || invoice.retrocessions.length === 0) return null;
        return invoice.retrocessions.sort((a, b) => b.amount - a.amount).map((retrocession, index) => {
            return <div key={index} className="valign-wrapper" style={{paddingLeft: 20, gap: 20}}>
                <StatusIcon status={retrocession.status}/>
                <h5 style={{
                    margin: 0,
                    marginBlock: 3
                }}>{retrocession.orthoptist_fullname} : {retrocession.amount / 100.0}€</h5>
            </div>
        })
    }

    return <div>
        {renderLine()}
    </div>
}

export default OphtalmologistEarningLine;